import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import styles from './ConfirmationModal.module.scss';

const ConfirmationModal = ({
    isOpen,
    toggle,
    title = 'Confirm Action',
    body = 'Are you sure you want to proceed?',
    confirmText = 'Yes',
    cancelText = 'Cancel',
    onConfirm,
    onCancel
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} className={styles.customModal}>
            <ModalHeader toggle={toggle} className={styles.modalHeader}>
                {title}
            </ModalHeader>
            <ModalBody className={styles.modalBody}>
                {body}
            </ModalBody>
            <ModalFooter className={styles.modalFooter}>
                <Button color="danger" onClick={onConfirm}>
                    {confirmText}
                </Button>
                <Button color="secondary" onClick={onCancel || toggle}>
                    {cancelText}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmationModal;
